export default __webpack_public_path__ + "static/blob-09-5c1e26559fe22e7f0380e55438579e84.svg";